<template>

  <div class="outer-content foreground blur">
    <div class="inner-content">
      <div class="exit_btn" @click="$emit('hide-about-box')"><img src="../assets-fca/UI/close_gray.svg"></div>
      <div class="scroll_content">
        <div class="grid_container">
          <!--Top section-->
          <div class="about_title" v-html="T('information_1')"></div>
          <div class="about_p1" v-html="T('information_2')"></div>
          <div class="about_p2" v-html="T('information_3')"></div>
          <!--<div class="info_title"><h2>Useful Player Information</h2></div>
          <div class="info_p"><a href="../assets/Player Menu Cards/J1895_NIWA_Township_Flood_Game_Cards_A4_V6.pdf" download="Player_Cards">Download these helpful player menu cards to have on hand while you play!</a></div>-->
          <!--How to win-->
          <div class="win_title" v-html="T('information_4')"></div>
          <div class="win_p" v-html="T('information_5')"></div>
          <!--Game pieces-->
          <div class="pieces_title" v-html="T('information_6')"></div>
          <!--Dice-->
          <div class="dice_title" v-html="T('information_7')"></div>
          <div class="dice_p" v-html="T('information_8')"></div>
          <div class="dice_title2" v-html="T('information_8b')"></div>
          <div class="dice_p2" v-html="T('information_8c')"></div>

          <div class="dice_IMG_container" id="dice_IMG_pos1_river">
            <div class="dice_IMG"><img src="../assets-fca/About_Icons/river-dice-none.svg"></div>
          </div>
          <div class="dice_IMG_container" id="dice_IMG_pos2_river">
            <div class="dice_IMG"><img src="../assets-fca/About_Icons/river-dice-high.svg"></div>
          </div>
          <div class="dice_IMG_container" id="dice_IMG_pos3_river">
            <div class="dice_IMG"><img src="../assets-fca/About_Icons/river-dice-severe.svg"></div>
          </div>
          <div class="dice_IMG_container" id="dice_IMG_pos1_ocean">
            <div class="dice_IMG"><img src="../assets-fca/About_Icons/ocean-dice-1-level.svg"></div>
          </div>
          <div class="dice_IMG_container" id="dice_IMG_pos2_ocean">
            <div class="dice_IMG"><img src="../assets-fca/About_Icons/ocean-dice-2-level.svg"></div>
          </div>
          <div class="dice_IMG_container" id="dice_IMG_pos3_ocean">
            <div class="dice_IMG"><img src="../assets-fca/About_Icons/ocean-dice-cyclone.svg"></div>
          </div>
          
          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Repairs-->
          <div class="repair_title" v-html="T('information_9')"></div>
          <div class="repair_p" v-html="T('information_10')"></div>
          <div class="repair_IMG"><img src="../assets-fca/About_Icons/make-repairs-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Next round-->
          <div class="round_title" v-html="T('information_11')"></div>
          <div class="round_p" v-html="T('information_12')"></div>
          <div class="round_IMG"><img src="../assets-fca/About_Icons/calendar-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Players-->
          <div class="player_title" v-html="T('information_13')"></div>
          <div class="player_p" v-html="T('information_14')"></div>
          <div class="player_IMG_default" id="player_IMG_pos1"><img class="player_IMG_size" src="../assets-fca/About_Icons/Ash-icon.svg"></div>
          <div class="player_IMG_default" id="player_IMG_pos2"><img class="player_IMG_size" src="../assets-fca/About_Icons/Nyah-icon.svg"></div>
          <div class="player_IMG_default" id="player_IMG_pos3"><img class="player_IMG_size" src="../assets-fca/About_Icons/Grace-icon.svg"></div>
          <div class="player_IMG_default" id="player_IMG_pos4"><img class="player_IMG_size" src="../assets-fca/About_Icons/Trev-icon.svg"></div>
          <div class="player_IMG_default" id="player_IMG_pos5"><img class="player_IMG_size" src="../assets-fca/About_Icons/Pania-icon.svg"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Redesign-->
          <div class="redesign_title" v-html="T('information_redesign_name')"></div>
          <div class="redesign_p" v-html="T('information_redesign_description')"></div>
          <div id="adv_title" class="redesign_adv_t" v-html="T('information_advantages')"></div>
          <div class="redesign_adv" v-html="T('information_redesign_advantages')"></div>
          <div id="dis_title" class="redesign_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="redesign_dis" v-html="T('information_redesign_disadvantages')"></div>
          <div id="lim_title" class="redesign_lim_t" v-html="T('information_limits')"></div>
          <div class="redesign_lim" v-html="T('information_redesign_limits')"></div>
          <div class="redesign_IMG"><img src="../assets-fca/About_Icons/raising-house-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Relocate-->
          <div class="relocate_title" v-html="T('information_relocate_name')"></div>
          <div class="relocate_p" v-html="T('information_relocate_description')"></div>
          <div id="adv_title" class="relocate_adv_t" v-html="T('information_advantages')"></div>
          <div class="relocate_adv" v-html="T('information_relocate_advantages')"></div>
          <div id="dis_title" class="relocate_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="relocate_dis" v-html="T('information_relocate_disadvantages')"></div>
          <div id="lim_title" class="relocate_lim_t" v-html="T('information_limits')"></div>
          <div class="relocate_lim" v-html="T('information_relocate_limits')"></div>
          <div class="relocate_IMG"><img src="../assets-fca/About_Icons/move-house-back-icon.svg" width="150px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Nature based solution-->
          <div class="nature_title" v-html="T('information_nature_name')"></div>
          <div class="nature_p" v-html="T('information_nature_description')"></div>
          <div id="adv_title" class="nature_adv_t" v-html="T('information_advantages')"></div>
          <div class="nature_adv" v-html="T('information_nature_advantages')"></div>
          <div id="dis_title" class="nature_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="nature_dis" v-html="T('information_nature_disadvantages')"></div>
          <div id="lim_title" class="nature_lim_t" v-html="T('information_limits')"></div>
          <div class="nature_lim" v-html="T('information_nature_limits')"></div>
          <div class="nature_IMG"><img src="../assets-fca/About_Icons/nature-based-solution-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Stopbank-->
          <div class="stopbank_title" v-html="T('information_stopbank_name')"></div>
          <div class="stopbank_p" v-html="T('information_stopbank_description')"></div>
          <div id="adv_title" class="stopbank_adv_t" v-html="T('information_advantages')"></div>
          <div class="stopbank_adv" v-html="T('information_stopbank_advantages')"></div>
          <div id="dis_title" class="stopbank_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="stopbank_dis" v-html="T('information_stopbank_disadvantages')"></div>
          <div id="lim_title" class="stopbank_lim_t" v-html="T('information_limits')"></div>
          <div class="stopbank_lim" v-html="T('information_stopbank_limits')"></div>
          <div class="stopbank_IMG"><img src="../assets-fca/About_Icons/stopbank-icon.svg"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Sea wall-->
          <div class="seawall_title" v-html="T('information_seawall_name')"></div>
          <div class="seawall_p" v-html="T('information_seawall_description')"></div>
          <div id="adv_title" class="seawall_adv_t" v-html="T('information_advantages')"></div>
          <div class="seawall_adv" v-html="T('information_seawall_advantages')"></div>
          <div id="dis_title" class="seawall_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="seawall_dis" v-html="T('information_seawall_disadvantages')"></div>
          <div id="lim_title" class="seawall_lim_t" v-html="T('information_limits')"></div>
          <div class="seawall_lim" v-html="T('information_seawall_limits')"></div>
          <div class="seawall_VID" v-html="T('information_seawall_video')"></div>
          <div class="seawall_IMG"><img src="../assets-fca/About_Icons/seawall-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Nature based solution sea-->
          <div class="sea_solution_title" v-html="T('information_nature_name_sea')"></div>
          <div class="sea_solution_p" v-html="T('information_nature_description_sea')"></div>
          <div id="adv_title" class="sea_solution_adv_t" v-html="T('information_advantages')"></div>
          <div class="sea_solution_adv" v-html="T('information_nature_advantages_sea')"></div>
          <div id="dis_title" class="sea_solution_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="sea_solution_dis" v-html="T('information_nature_disadvantages_sea')"></div>
          <div id="lim_title" class="sea_solution_lim_t" v-html="T('information_limits')"></div>
          <div class="sea_solution_lim" v-html="T('information_nature_limits_sea')"></div>
          <div class="sea_solution_IMG"><img src="../assets-fca/About_Icons/nature-based-solution-(sea)-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider"></div>
          <!--Groundwater pumps-->
          <div class="pumps_title" v-html="T('information_groundwater_pumps_name')"></div>
          <div class="pumps_p" v-html="T('information_groundwater_pumps_description')"></div>
          <div id="adv_title" class="pumps_adv_t" v-html="T('information_advantages')"></div>
          <div class="pumps_adv" v-html="T('information_groundwater_pumps_advantages')"></div>
          <div id="dis_title" class="pumps_dis_t" v-html="T('information_disadvantages')"></div>
          <div class="pumps_dis" v-html="T('information_groundwater_pumps_disadvantages')"></div>
          <div id="lim_title" class="pumps_lim_t" v-html="T('information_limits')"></div>
          <div class="pumps_lim" v-html="T('information_groundwater_pumps_limits')"></div>
          <div class="pumps_IMG"><img src="../assets-fca/About_Icons/drainage-pump-icon.svg" width="131px"></div>

          <!--Grid line-->
          <div class="row_divider_large"></div>
          <!--Maori glossary-->
          <div class="gloss_title" v-html="T('information_maori')"></div>
          <div class="gloss_mar" v-html="T('information_marae')"></div>
          <div class="gloss_marD" v-html="T('information_marae_description')"></div>
          <div class="gloss_IMG_box" id="gloss_IMG_pos1"><img class="gloss_IMG" src="../assets-fca/Active Properties/wharenui.svg"></div>
          <!--Grid line-->
          <div class="row_divider"></div>
          <div class="gloss_wha" v-html="T('information_whare')"></div>
          <div class="gloss_whaD" v-html="T('information_whare_description')"></div>
          <div class="gloss_IMG_box" id="gloss_IMG_pos2"><img class="gloss_IMG" src="../assets-fca/Active Properties/wharekai.svg"></div>
          <!--Grid line-->
          <div class="row_divider"></div>
          <div class="gloss_pap" v-html="T('information_papakainga')"></div>
          <div class="gloss_papD" v-html="T('information_papakainga_description')"></div>
          <div class="gloss_IMG_box" id="gloss_IMG_pos3"><img class="pap_IMG" src="../assets-fca/Active Properties/papakainga.svg"></div>
          <!--Grid line-->
          <div class="row_divider"></div>
          <div class="gloss_uru" v-html="T('information_urupa')"></div>
          <div class="gloss_uruD" v-html="T('information_urupa_description')"></div>
          <div class="gloss_IMG_box" id="gloss_IMG_pos4"><img class="uru_IMG" src="../assets-fca/Active Properties/urupa.svg"></div>
      </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'AboutBox',
  methods: {
    T(key: string): string {
      return T(key);
    }
  }
});
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

/*Info box general*/
a {
  color: #333333;
  font-family: rubik;
}


.inner-content {
  height: 800px;
  width: 1150px;
  background-color: white;
  border-radius: 20px;
}

.scroll_content {
  width: 1050px;
  height: 650px;
  margin: auto;
  margin-top: 80px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.exit_btn {
  position: absolute;
  top: 20px;
  right: 25px;
  cursor: pointer;
}

.grid_container {
  display: grid;
  grid-template-columns: 300px 730px;
  grid-template-rows: repeat(auto);
  row-gap: 10px;
}

.row_divider {
  border-top: 3px solid grey;
  border-radius: 30px;
  grid-column: 1 / 3;
  margin-top: 40px;
  margin-bottom: 40px;
}

.row_divider_large {
  border-top: 10px solid grey;
  border-radius: 2px;
  grid-column: 1 / 3;
  margin-top: 40px;
  margin-bottom: 40px;
}

#adv_title, #dis_title, #lim_title {
  font-size: 25px;
  font-weight: 500;
}

/*About section*/
.about_title, .about_p1, .about_p2, .win_title, .win_p, .info_title, .info_p {
  grid-column: span 2;
}

.win_title, .pieces_title {
  margin-top: 20px;
}

/*Pieces*/
.pieces_title {
  grid-column: span 2;
}

/*Dice*/
.dice_title, .dice_title2, .dice_p, .dice_p2{
  grid-column: 2;
}

.dice_title2 {
  margin-top: 50px;
}

.dice_IMG_container {
  width: 73px;
  height: 73px;
  background: #d8d8d8;
  border-radius: 100%;
  grid-column: 1;
}

#dice_IMG_pos1_river {
  grid-row: 7 / 9;
  margin-left: 5%;
}

#dice_IMG_pos2_river {
  grid-row: 7 / 9;
  margin-left: 40%;
}

#dice_IMG_pos3_river {
  grid-row: 7 / 9;
  margin-left: 23%;
  margin-top: 30%;
}

#dice_IMG_pos1_ocean {
  grid-row: 9 / 11;
  margin-left: 5%;
  margin-top: 18%;
}

#dice_IMG_pos2_ocean {
  grid-row: 9 / 11;
  margin-left: 40%;
  margin-top: 18%;
}

#dice_IMG_pos3_ocean {
  grid-row: 9 / 11;
  margin-left: 23%;
  margin-top: 48%;
}

.dice_IMG {
  margin: auto;
  padding-top: 10%;
  width: 55px;
}

/*Repairs*/
.repair_title, .repair_p {
  grid-column: 2;
}

.repair_IMG {
  grid-column: 1;
  grid-row: 12 / 14;
  margin-left: 15%;
  width: 131px;
}

/*Next round*/
.round_title, .round_p {
  grid-column: 2;
}

.round_IMG {
  grid-column: 1;
  grid-row: 15 / 17;
  margin-left: 15%;
  width: 131px;
}

/*Players*/
.player_title, .player_p {
  grid-column: 2;
}

.player_IMG_default {
  width: 60px;
  height: 60px;
  grid-column: 1;
  grid-row: 18 / 20;
}

.player_IMG_size {
  width: 60px;
  height: 60px;
}

#player_IMG_pos1 {
  margin-left: 5%;
}

#player_IMG_pos2 {
  margin-left: 28%;
}

#player_IMG_pos3 {
  margin-left: 51%;
}

#player_IMG_pos4 {
  margin-left: 16%;
  margin-top: 20%;
}

#player_IMG_pos5 {
  margin-left: 39%;
  margin-top: 20%;
}

/*Redesign*/
.redesign_title, .redesign_p, .redesign_adv_t, .redesign_adv, .redesign_dis_t, .redesign_dis, .redesign_lim_t, .redesign_lim {
  grid-column: 2;
}

.redesign_IMG {
  grid-column: 1;
  grid-row: 21 / 29;
  margin-left: 15%;
  width: 131px;
}

/*Relocate*/
.relocate_title, .relocate_p, .relocate_adv_t, .relocate_adv, .relocate_dis_t, .relocate_dis, .relocate_lim_t, .relocate_lim {
  grid-column: 2;
}

.relocate_IMG {
  grid-column: 1;
  grid-row: 30 / 38;
  margin-left: 15%;
  width: 131px;
}

/*Nature based solution*/
.nature_title, .nature_p, .nature_adv_t, .nature_adv, .nature_dis_t, .nature_dis, .nature_lim_t, .nature_lim {
  grid-column: 2;
}

.nature_IMG {
  grid-column: 1;
  grid-row: 39 / 42;
  margin-left: 15%;
  width: 131px;
}

/*Stopbank*/
.stopbank_title, .stopbank_p, .stopbank_adv_t, .stopbank_adv, .stopbank_dis_t, .stopbank_dis, .stopbank_lim_t, .stopbank_lim {
  grid-column: 2;
}

.stopbank_IMG {
  grid-column: 1;
  grid-row: 48 / 51;
  margin-left: 15%;
  width: 131px;
}

/*Sea wall*/
.seawall_title, .seawall_p, .seawall_adv_t, .seawall_adv, .seawall_dis_t, .seawall_dis, .seawall_lim_t, .seawall_lim {
  grid-column: 2;
}

.seawall_IMG {
  grid-column: 1;
  grid-row: 57 / 60;
  margin-left: 15%;
  width: 131px;
}

.seawall_VID {
  grid-column: 2;
  margin-top: 25px;
}

/*Seaside nature based solution*/
.sea_solution_title, .sea_solution_p, .sea_solution_adv_t, .sea_solution_adv, .sea_solution_dis_t, .sea_solution_dis, .sea_solution_lim_t, .sea_solution_lim {
  grid-column: 2;
}

.sea_solution_IMG {
  grid-column: 1;
  grid-row: 67 / 70;
  margin-left: 15%;
  width: 131px;
}

/*Groundwater pumps*/
.pumps_title, .pumps_p, .pumps_adv_t, .pumps_adv, .pumps_dis_t, .pumps_dis, .pumps_lim_t, .pumps_lim {
  grid-column: 2;
}

.pumps_IMG {
  grid-column: 1;
  grid-row: 76 / 79;
  margin-left: 15%;
  width: 131px;
}

/*Maori glossary*/
.gloss_title {
  grid-column: span 2;
  margin-bottom: 25px;
}

.gloss_mar, .gloss_marD, .gloss_wha, .gloss_whaD, .gloss_pap, .gloss_papD, .gloss_uru, .gloss_uruD {
  grid-column: 2;
}

.gloss_IMG_box {
  width: 131px;
  height: 131px;
  margin-left: 15%;
  border-radius: 100%;
}

.gloss_IMG {
  margin: auto;
  padding-top: 15%;
  width: 100%;
}

#gloss_IMG_pos1 {
  grid-row: 86 / 88;
}

#gloss_IMG_pos2 {
  grid-row: 89 / 91;
}

#gloss_IMG_pos3 {
  grid-row: 92 / 94;
}

.pap_IMG {
  margin: auto;
  width: 100%;
  margin-top: -25%;
}

#gloss_IMG_pos4 {
  grid-row: 95 / 97;
}

.uru_IMG {
  margin: auto;
  width: 100%;
  margin-top: 40%;
}
</style>